(function () {
  if (!document.body) return;
  const supportsCollectionCardCarousel =
    document.body.classList.contains('template-collection') ||
    document.body.classList.contains('template-search');
  if (!supportsCollectionCardCarousel) return;

  const $ = window.jQuery;
  const canUseSlick = !!($ && $.fn && $.fn.slick);
  const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  const mobileScrollState = new WeakMap();
  const desktopClickState = new WeakMap();
  const MOBILE_TAP_DRAG_THRESHOLD = 8;

  const prevArrow =
    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.51 30.73"><path d="M17.24 1.5L1.5 15.36l15.74 13.87" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25"/></svg></button>';
  const nextArrow =
    '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.51 30.73"><path d="M2.27 1.5l15.74 13.86L2.27 29.23" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25"/></svg></button>';

  let observer = null;

  function isMobileViewport() {
    return !!(mobileQuery && mobileQuery.matches);
  }

  function syncMobileSlideWidth(mediaElement) {
    if (!mediaElement) return;
    const slideWidth = Math.max(1, Math.round(mediaElement.clientWidth) + 1);
    mediaElement.style.setProperty('--ddla-mobile-slide-width', slideWidth + 'px');
  }

  function updateMobileProgress(mediaElement) {
    if (!mediaElement) return;

    const wrapper = mediaElement.closest('.collection-card-media-wrapper');
    if (!wrapper) return;

    const configuredSlideCount = 3;
    const maxScroll = Math.max(0, mediaElement.scrollWidth - mediaElement.clientWidth);
    const normalized = maxScroll > 0 ? mediaElement.scrollLeft / maxScroll : 0;
    const progress = Math.max(0, Math.min(1, normalized));
    const isScrollable = maxScroll > 1;

    const wrapperStyles = window.getComputedStyle(wrapper);
    const marginToken = (wrapperStyles.getPropertyValue('--ddla-mobile-scroll-margin') || '').trim();
    let trackMarginPx = 12;

    if (marginToken.endsWith('rem')) {
      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
      trackMarginPx = (parseFloat(marginToken) || 0) * rootFontSize;
    } else if (marginToken.endsWith('px')) {
      trackMarginPx = parseFloat(marginToken) || 12;
    } else if (marginToken) {
      trackMarginPx = parseFloat(marginToken) || 12;
    }

    const trackWidthPx = Math.max(0, wrapper.clientWidth - (trackMarginPx * 2));
    const thumbWidthPx = trackWidthPx / configuredSlideCount;
    const maxTranslatePx = Math.max(0, trackWidthPx - thumbWidthPx);
    const thumbTranslatePx = maxTranslatePx * progress;

    wrapper.style.setProperty('--ddla-mobile-progress', String(progress));
    wrapper.style.setProperty('--ddla-mobile-thumb-width', thumbWidthPx.toFixed(3) + 'px');
    wrapper.style.setProperty('--ddla-mobile-thumb-translate', thumbTranslatePx.toFixed(3) + 'px');
    wrapper.classList.toggle('collection-card-media-wrapper--mobile-scrollable', isScrollable);
  }

  function setupMobileScroll(mediaElement) {
    if (!mediaElement) return;

    teardownDesktopClick(mediaElement);

    const wrapper = mediaElement.closest('.collection-card-media-wrapper');

    if (canUseSlick) {
      const $mediaElement = $(mediaElement);
      if ($mediaElement.hasClass('slick-initialized')) {
        $mediaElement.slick('unslick');
      }
    }

    mediaElement.classList.add('collection-card-media--mobile-scroll');
    syncMobileSlideWidth(mediaElement);
    if (wrapper) {
      wrapper.classList.add('collection-card-media-wrapper--mobile-scroll');
    }

    if (!mobileScrollState.has(mediaElement)) {
      const productLink = wrapper ? wrapper.querySelector('.collection-card-media-link') : null;
      const tapState = {
        tracking: false,
        moved: false,
        startX: 0,
        startY: 0,
        startScrollLeft: 0
      };

      const onScroll = function () {
        updateMobileProgress(mediaElement);
      };

      const onPointerDown = function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (!productLink || !productLink.href) return;
        if (event.target && event.target.closest('button, .slick-arrow')) return;

        tapState.tracking = true;
        tapState.moved = false;
        tapState.startX = event.clientX;
        tapState.startY = event.clientY;
        tapState.startScrollLeft = mediaElement.scrollLeft;
      };

      const onPointerMove = function (event) {
        if (!tapState.tracking || tapState.moved) return;

        const deltaX = Math.abs(event.clientX - tapState.startX);
        const deltaY = Math.abs(event.clientY - tapState.startY);
        const deltaScroll = Math.abs(mediaElement.scrollLeft - tapState.startScrollLeft);

        if (deltaX > MOBILE_TAP_DRAG_THRESHOLD || deltaY > MOBILE_TAP_DRAG_THRESHOLD || deltaScroll > MOBILE_TAP_DRAG_THRESHOLD) {
          tapState.moved = true;
        }
      };

      const onPointerUp = function (event) {
        if (!tapState.tracking) return;

        const shouldNavigate = !tapState.moved && productLink && productLink.href && !(event.target && event.target.closest('button, .slick-arrow, a'));
        tapState.tracking = false;

        if (shouldNavigate) {
          window.location.href = productLink.href;
        }
      };

      const onPointerCancel = function () {
        tapState.tracking = false;
      };

      mediaElement.addEventListener('scroll', onScroll, { passive: true });
      mediaElement.addEventListener('pointerdown', onPointerDown, { passive: true });
      window.addEventListener('pointermove', onPointerMove, { passive: true });
      window.addEventListener('pointerup', onPointerUp, { passive: true });
      window.addEventListener('pointercancel', onPointerCancel, { passive: true });

      mobileScrollState.set(mediaElement, {
        onScroll: onScroll,
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerUp: onPointerUp,
        onPointerCancel: onPointerCancel
      });
    }

    mediaElement.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        updateMobileProgress(mediaElement);
      }, { once: true });
    });

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          updateMobileProgress(mediaElement);
        });
      });
    } else {
      setTimeout(function () {
        updateMobileProgress(mediaElement);
      }, 0);
    }

    mediaElement.dataset.collectionMobileScrollReady = 'true';
    mediaElement.dataset.collectionCarouselReady = 'true';
  }

  function teardownMobileScroll(mediaElement) {
    if (!mediaElement) return;

    const state = mobileScrollState.get(mediaElement);
    if (state) {
      if (state.onScroll) {
        mediaElement.removeEventListener('scroll', state.onScroll);
      }
      if (state.onPointerDown) {
        mediaElement.removeEventListener('pointerdown', state.onPointerDown);
      }
      if (state.onPointerMove) {
        window.removeEventListener('pointermove', state.onPointerMove);
      }
      if (state.onPointerUp) {
        window.removeEventListener('pointerup', state.onPointerUp);
      }
      if (state.onPointerCancel) {
        window.removeEventListener('pointercancel', state.onPointerCancel);
      }
    }
    mobileScrollState.delete(mediaElement);

    mediaElement.classList.remove('collection-card-media--mobile-scroll');
    mediaElement.style.removeProperty('--ddla-mobile-slide-width');
    delete mediaElement.dataset.collectionMobileScrollReady;

    const wrapper = mediaElement.closest('.collection-card-media-wrapper');
    if (wrapper) {
      wrapper.classList.remove('collection-card-media-wrapper--mobile-scroll');
      wrapper.classList.remove('collection-card-media-wrapper--mobile-scrollable');
      wrapper.style.removeProperty('--ddla-mobile-progress');
      wrapper.style.removeProperty('--ddla-mobile-thumb-width');
      wrapper.style.removeProperty('--ddla-mobile-thumb-translate');
    }
  }

  function teardownDesktopClick(mediaElement) {
    if (!mediaElement) return;
    const state = desktopClickState.get(mediaElement);
    if (state) {
      const wrapper = mediaElement.closest('.collection-card-media-wrapper');
      if (wrapper && state.onClick) {
        wrapper.removeEventListener('click', state.onClick);
      }
    }
    desktopClickState.delete(mediaElement);
  }

  function initDesktopCarousel(mediaElement) {
    if (!mediaElement) return;

    teardownMobileScroll(mediaElement);

    if (!canUseSlick) {
      mediaElement.dataset.collectionCarouselReady = 'true';
      return;
    }

    const $mediaElement = $(mediaElement);
    if ($mediaElement.hasClass('slick-initialized')) return;

    const slideCount = mediaElement.children.length;
    if (slideCount <= 1) {
      mediaElement.dataset.collectionCarouselReady = 'true';
      return;
    }

    $mediaElement.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      speed: 250,
      waitForAnimate: false,
      mobileFirst: true
    });

    mediaElement.dataset.collectionCarouselReady = 'true';

    if (!desktopClickState.has(mediaElement)) {
      const wrapper = mediaElement.closest('.collection-card-media-wrapper');
      const productLink = wrapper ? wrapper.querySelector('.collection-card-media-link') : null;
      if (wrapper && productLink && productLink.href) {
        const onClick = function (event) {
          if (event.target && event.target.closest('.slick-arrow, button, a')) return;
          window.location.href = productLink.href;
        };
        wrapper.addEventListener('click', onClick);
        desktopClickState.set(mediaElement, { onClick: onClick });
      }
    }
  }

  function initCarousel(mediaElement) {
    if (!mediaElement) return;

    if (isMobileViewport()) {
      setupMobileScroll(mediaElement);
      return;
    }

    initDesktopCarousel(mediaElement);
  }

  function observeCarousel(mediaElement) {
    if (!mediaElement || mediaElement.dataset.collectionCarouselObserved === 'true') return;

    mediaElement.dataset.collectionCarouselReady = 'false';

    if (!observer) {
      initCarousel(mediaElement);
      return;
    }

    mediaElement.dataset.collectionCarouselObserved = 'true';
    observer.observe(mediaElement);
  }

  function initWithin(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-collection-card-carousel]').forEach((mediaElement) => {
      observeCarousel(mediaElement);
    });
  }

  function destroyCarousel(mediaElement) {
    if (!mediaElement) return;

    teardownMobileScroll(mediaElement);
    teardownDesktopClick(mediaElement);

    if (canUseSlick) {
      const $mediaElement = $(mediaElement);
      if ($mediaElement.hasClass('slick-initialized')) {
        $mediaElement.slick('unslick');
      }
    }

    mediaElement.dataset.collectionCarouselReady = 'false';
    delete mediaElement.dataset.collectionCarouselObserved;
  }

  function refreshCarousel(mediaElement) {
    if (!mediaElement) return;
    destroyCarousel(mediaElement);
    observeCarousel(mediaElement);
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initCarousel(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '300px 0px'
      }
    );
  }

  function refreshAll() {
    document.querySelectorAll('[data-collection-card-carousel]').forEach(function (mediaElement) {
      refreshCarousel(mediaElement);
    });
  }

  function updateAllMobileProgress() {
    if (!isMobileViewport()) return;

    document.querySelectorAll('[data-collection-card-carousel]').forEach(function (mediaElement) {
      if (mediaElement.dataset.collectionMobileScrollReady === 'true') {
        syncMobileSlideWidth(mediaElement);
        updateMobileProgress(mediaElement);
      }
    });
  }

  window.CollectionCardMedia = {
    initWithin: initWithin,
    destroy: destroyCarousel,
    refresh: refreshCarousel
  };

  function boot(root) {
    initWithin(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  if (mobileQuery) {
    const onViewportChange = function () {
      refreshAll();
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onViewportChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onViewportChange);
    }
  }

  window.addEventListener('resize', updateAllMobileProgress, { passive: true });

  document.addEventListener('collection:card-media-updated', function (event) {
    if (!event.detail || !event.detail.mediaElement) return;
    refreshCarousel(event.detail.mediaElement);
  });

  const productGridContainer = document.getElementById('ProductGridContainer');

  if (productGridContainer && 'MutationObserver' in window) {
    const gridObserver = new MutationObserver(function (mutations) {
      let shouldBoot = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches('[data-collection-card-carousel]') || node.querySelector('[data-collection-card-carousel]')) {
            shouldBoot = true;
          }
        });
      });

      if (shouldBoot) {
        boot(productGridContainer);
      }
    });

    gridObserver.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }
})();